export const relativeUrls = {
  caseStudy: "/case-study",
  contact: "/contact",
  home: "/",
  pricing: "/pricing",
  terms: "/terms"
};
